import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { Metamodel } from 'app/model/base/model';
import { GoogleAdWordsObjectDataset } from 'app/model/dataset/google-adwords.dataset';
import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(GoogleAdWordsObjectDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class GoogleAdWordsObjectDatasetAdapter extends TabularTypeDatasetAdapter<GoogleAdWordsObjectDataset, Model.DatasetResource> {
    protected async _toResource(dataset: GoogleAdWordsObjectDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(GoogleAdWordsObjectDataset).name);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: GoogleAdWordsObjectDataset): Promise<GoogleAdWordsObjectDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, GoogleAdWordsObjectDataset.MODEL);
    }
}
